module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/siteclose-a1574deb4da5684f7dd0f305b302d91d.svg&quot;;"